@import '~less/global-variables';
@import '~less/layout/helpers';

/**
 * Thread
 */

#messages-thread {
  // Scrollbars for Chrome/Safari
  &::-webkit-scrollbar {
    width: 15px;
    height: 20px;
  }
  &::-webkit-scrollbar-thumb {
    height: 6px;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    -webkit-border-radius: 7px;
    background-color: rgba(0, 0, 0, 0.15);
    -webkit-box-shadow:
      inset -1px -1px 0px rgba(0, 0, 0, 0.05),
      inset 1px 1px 0px rgba(0, 0, 0, 0.05);
  }
  &::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

// Single message in the thread
.message {
  word-wrap: break-word;
  @media (min-width: @screen-sm-min) {
    .panel {
      .panel-triangle-right();
    }
  }
  &.message-sender-other.message-unread {
    .panel {
      border-left-color: @brand-primary;
      border-left-width: 2px;
      // Pause for 1s before making 2s linear animation for any CSS change
      // @link http://www.w3schools.com/css/css3_transitions.asp
      transition: all 2s linear 1s;
    }
  }

  // "Yes, I can host!" messages
  &[data-hosting='yes'] {
    .panel-body {
      color: @offer-hosting-yes;
    }
    .panel {
      border-color: @offer-hosting-yes;
      &:before {
        border-left-color: @offer-hosting-yes;
      }
    }
  }

  // "Sorry, I can't host" messages
  &[data-hosting='no'] {
    .panel-body {
      color: @offer-hosting-no;
    }
    .panel {
      border-color: @offer-hosting-no;
      &:before {
        border-left-color: @offer-hosting-no;
      }
    }
  }

  .divider {
    display: block;
    clear: both;
    margin: 10px 0;
    &.divider-first {
      margin-top: 0;
      @media (max-width: @screen-xs-max) {
        text-align: center;
        margin-bottom: 25px;
      }
    }
    &.divider-last {
      margin-bottom: 0;
    }
  }
  .message-author {
    text-align: center;
    .avatar {
      margin: 25px auto @padding-small-vertical auto;
    }
  }
  .message-meta {
    display: inline-block;
    font-size: @font-size-small;
    padding-right: 3px;
    &,
    a {
      .text-muted();
    }
  }
  .message-meta {
    display: block;
    text-align: right;
    clear: both;
    overflow: hidden;
    .link-badge {
      margin-bottom: 0;
    }
  }
  p:last-child {
    margin-bottom: 0;
  }
}

// Reply box
#message-reply {
  display: flex;
  flex-direction: column;
  // The message list is the flexible, scrollable part of the thread. Letting
  // the form shrink makes long conversations collapse the editor until its
  // text and the actions row overlap.
  flex: 0 0 auto;
  min-height: 0;
  max-height: ~'max(100px, 50vh)';
  overflow: hidden;

  .message-reply-resize-handle {
    flex: 0 0 16px;
    cursor: ns-resize;
    touch-action: none;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;

    &:before {
      content: '';
      width: 40px;
      height: 4px;
      border-radius: 2px;
      background: @gray-light;
    }

    &:focus-visible {
      outline: 2px solid @brand-primary;
      outline-offset: -2px;
    }
  }

  .message-reply-editor-row {
    flex: 1 1 auto;
    margin-bottom: 0;
    min-height: 0;
  }

  .message-reply-actions {
    flex: 0 0 auto;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;

    > small {
      flex: 1;
    }
  }

  .message-draft-preview {
    overflow: auto;
    max-height: ~'min(250px, calc(50vh - 55px))';

    .message {
      margin: 4px 0;
    }

    .panel .panel-body {
      padding: 12px 16px;
      background: #e1f5ed;
    }

    @media (max-width: @screen-xs-max) {
      max-height: ~'min(100px, calc(25vh - 55px))';

      .panel {
        margin: 0;
        border-radius: 16px 16px 4px 16px;
      }
    }
  }

  .message-preview-toggle {
    @media (max-width: @screen-xs-max) {
      margin-left: -15px;
    }
  }

  // No color glow on hover with this Medium editor instance
  .tr-editor {
    &:hover {
      background: transparent;
    }
  }
  .message-reply-title {
    margin: 0;
    float: left;
    font-size: 13px;
    line-height: 13px;
  }
  .panel {
    margin-bottom: @padding-xs-horizontal;
    .panel-body {
      padding: @padding-xs-horizontal;
      background: @gray-lighter;
    }
    #message-reply-content {
      transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s;
      font-size: @font-size-base;
      line-height: @line-height-base;
      padding: @padding-base-vertical @padding-base-horizontal;
      border: 0;
      border-top: 1px solid transparent;
      padding-top: 5px;
      margin-bottom: 0;
      min-height: 53px;
      // Reserve space for the send-actions row inside the 50vh composer cap.
      max-height: ~'min(250px, calc(50vh - 61px))';
      overflow: auto;
      resize: none;
      &:focus {
        outline: none;
        box-shadow: none;
        border-color: @brand-primary;
      }
      &:after {
        margin: 0;
        top: 9px;
        left: 12px;
      }
      p {
        margin: 0;
      }
      @media (max-width: @screen-xs-max) {
        padding-right: 45px;
        padding-top: 8px;
        margin-bottom: 0px;
        min-height: 43px;
        border-radius: 0;
        max-height: ~'min(100px, calc(25vh - 61px))';
        &:after {
          top: 2px;
          left: 5px;
        }
      }
    }
    @media (max-width: @screen-xs-max) {
      margin-bottom: -1px;
      margin-left: -15px;
      margin-right: 15px;
      border-radius: 0;
    }
  }
  .message-reply-btn {
    float: right;
    // Fix button to the bottom of the screen so that it
    // won't escape upwards when textarea next to it grows
    @media (max-width: @screen-xs-max) {
      height: 45px;
      width: 45px;
      bottom: var(--trustroots-keyboard-inset, 0px);
      right: 0;
      position: fixed;
      border-radius: 0;
    }
  }
  @media (max-width: @screen-xs-max) {
    max-height: ~'max(100px, 25vh)';
  }

  // The thread container follows the virtual keyboard inset. Clamp manually
  // resized composers to it, with room left for the conversation above.
  &.message-reply-resized {
    max-height: 80%;

    .message-reply-editor-row {
      display: flex;
      flex-wrap: nowrap;
      margin-bottom: 0;

      > div {
        display: flex;
        flex-direction: column;
        min-height: 0;
        width: 100%;
      }

      > div > .panel,
      .message-draft-preview {
        flex: 1 1 auto;
        min-height: 0;
        max-height: none;
        margin-bottom: 0;
      }

      > div > .panel {
        display: flex;
        flex-direction: column;
      }
    }

    .panel #message-reply-content {
      flex: 1 1 auto;
      min-height: 0;
      max-height: none;
    }
  }
}
